import * as React from "react";
import {cx} from "emotion";

import "./payment-panel.scss";

import {cs}             from "@Common/react/chain-services";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {chain}          from "@Common/utils/fs";
import {omit}           from "@Common/utils/objects";

export const PaymentPanel = ({title, content, className=undefined, hasError=false, controls=undefined, domRef=undefined}) => cs(
    () => (
        <div className={cx("payment-panel-9e9", className, {hasError})} ref={domRef}>
            <div className="header">
                <div className="text" xd-qa-type="label" xd-qa-name={title}>
                    {title}
                </div>
                {controls && (
                    <div {...{
                        className: "controls",
                        onClick: () => !controls.checkbox.disabled && (
                            controls.checkbox.onChange(!controls.checkbox.value)
                        ),
                    }}>
                        {controls.text && (
                            <div className="text" xd-qa-type="text" xd-qa-name={controls.text}>
                                {controls.text}
                            </div>
                        )}
                        {controls.status && (
                            <div className="status" xd-qa-type="text" xd-qa-name={controls.status}>
                                {controls.status}
                            </div>
                        )}
                        {SliderCheckbox(omit(controls.checkbox, ["onChange"]))}
                    </div>
                )}
            </div>

            {chain(
                content(),
                (c) => !!c&&(
                    <div className="content">
                        {c}
                    </div>
                ),
            )}
        </div>
    )
)